import React, { useEffect } from "react";
import InputText from "../../../../common/Input/InputText";
import { getAllLabReport } from "../../../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllPhysician } from "../../../../../store/slices/physicianSlice";
import Select from "react-select";

const AssignedAndRemark = ({ radiologyReportFormData, handleChange }) => {
  const dispatch = useDispatch();
  const { physician } = useSelector((state) => state.physician);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const labReportId = sessionStorage.getItem("labReportId");
  const clinicId = clinicInfo?.[0]?.clinicId;
  useEffect(() => {
    dispatch(getAllLabReport({ clinicId, id: labReportId, token }));
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      }),
    );
  }, [dispatch, clinicId, labReportId, token]);

  const newPhysician =
    physician &&
    physician?.filter((item) => {
      const hasPathologist = item.specialization.some((spec) => {
        return spec.specialization.toLowerCase() === "radiologist";
      });
      return hasPathologist;
    });

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="mb-4">Assigned and Remark</h4>
        <div className="row">
          <div className="col-xl-3">
            <label htmlFor="message-text" className="col-form-label mb-2">
              Select Physician
            </label>
            <Select
              name="assignedPhysician"
              placeholder="Select Physician"
              onChange={(e) => handleChange(e, "assignedPhysician")}
              value={{
                value: radiologyReportFormData?.assignedPhysician,
                label: radiologyReportFormData?.assignedPhysicianName,
              }}
              options={
                newPhysician &&
                newPhysician?.map((item) => ({
                  value: item._id,
                  label: item?.userId?.name,
                }))
              }
            />
          </div>
          <div className="col-xl-9">
            <InputText
              name="remark"
              value={radiologyReportFormData?.remark}
              onChange={(e) => handleChange(e)}
              label="Any Remark"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedAndRemark;
